import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay, catchError } from 'rxjs/operators';
import { AUTH_VERSION_CACHE_KEY, baseURL } from '../constant/constant';
import { ResponseCommon } from 'src/app/components/dtos/Common.dto';

export interface ConfigurationItem {
  version: string;
}

// Mirrors webapp-edc's src/app/services/edcServices/configuration.service.ts.
@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  private configUrl = `${baseURL}configuration`;

  private configuration: Observable<ResponseCommon<ConfigurationItem>> | null = null;
  readonly appVersion$ = new BehaviorSubject<string>(sessionStorage.getItem(AUTH_VERSION_CACHE_KEY) || '');

  constructor(private http: HttpClient) {}

  getConfiguration(): Observable<ResponseCommon<ConfigurationItem>> {
    if (!this.configuration) {
      this.configuration = this.http.get<ResponseCommon<ConfigurationItem>>(this.configUrl).pipe(
        shareReplay(1),
        catchError((error) => {
          this.configuration = null;
          throw error;
        })
      );
    }
    return this.configuration;
  }

  loadAppVersion(): void {
    this.getConfiguration().subscribe({
      next: (res) => {
        const version = res?.responseObject?.version;
        if (version) {
          sessionStorage.setItem(AUTH_VERSION_CACHE_KEY, version);
          this.appVersion$.next(version);
        }
      },
      error: () => console.error('Failed to load application configuration.')
    });
  }
}
